import { SourceSyncStatus } from "@gx/ts-contracts/services/database/models/public_pb";
import { SourceSyncResource } from "@gx/ts-contracts/services/source/resources/source_sync_pb";

import {
  BROWSERBASE_LIVE_SOURCE_SYNC_STATUSES,
  BROWSERBASE_TERMINAL_SOURCE_SYNC_STATUSES,
} from "@/pages/sources/components/edit/tabs/syncs/browserbase/constants";
import { BrowserbaseReplayEvent } from "@/pages/sources/components/edit/tabs/syncs/browserbase/types";
import { isSourceSyncMetadataBrowserbase } from "@/pages/sources/components/edit/tabs/syncs/utils";

export async function fetchRecording(downloadUri: string): Promise<BrowserbaseReplayEvent[]> {
  const response = await fetch(downloadUri);
  if (!response.ok) {
    throw new Error(`Failed to fetch recording: ${response.status}`);
  }
  return response.json() as Promise<BrowserbaseReplayEvent[]>;
}

export function extractSyncMetadata(sync: SourceSyncResource) {
  const metadata =
    sync.metadata && isSourceSyncMetadataBrowserbase(sync.metadata)
      ? sync.metadata.metadata.value
      : null;

  const status = sync.syncStatus ?? SourceSyncStatus.UNSPECIFIED;

  return {
    liveViewLink: metadata?.liveViewLink ?? "",
    sessionRecordingUri: metadata?.sessionRecordingUri,
    isLive: BROWSERBASE_LIVE_SOURCE_SYNC_STATUSES.includes(status),
    isTerminal: BROWSERBASE_TERMINAL_SOURCE_SYNC_STATUSES.includes(status),
  };
}
